import InterviewReview from './InterviewReview.container';

export default InterviewReview;
